import { modalId, useModalContext } from '@/features/world-map/context/modal';
import { usePlaceInfoContext } from '@/features/world-map/context/place-info';
import { useCruises } from '@/features/world-map/hooks/use-cruises';
import { useZoom } from '@/hooks/use-zoom';
import { Spinner } from '@/ui/spinner/spinner';
import { FilterButton } from '../filter-button/filter-button';
import classes from './cruises-header.module.css';

// Keep minZoom order low to high
const areaConfig = [
  { label: 'these continents', minZoom: 3 },
  { label: 'these countries', minZoom: 5 },
  { label: 'these regions', minZoom: 8 },
  { label: 'this area', minZoom: Infinity },
];

/**
 * @returns {React.JSX.Element}
 */
export function CruisesHeader() {
  const { totalRecords, isFetching, isLoading } = useCruises();
  const { placeInfo } = usePlaceInfoContext();
  const { setActiveModalId } = useModalContext();
  const zoom = useZoom();

  const showFilters = (/** @type {React.UIEvent} */ event) => {
    event.stopPropagation();
    setActiveModalId(modalId.filters);
  };

  const getAreaLabel = () => {
    if (placeInfo?.place) {
      return 'this port';
    }

    return areaConfig.find((destinationLabel) => zoom <= destinationLabel.minZoom)?.label ?? 'these destinations';
  };

  return (
    <div className={`${classes.cruisesHeader} ${totalRecords === 0 ? classes.zeroCruises : ''}`}>
      <h1 className={classes.title}>
        {isLoading ? (
          <>Searching for itineraries...</>
        ) : totalRecords ? (
          <>Itineraries that visit {getAreaLabel()}</>
        ) : (
          <>No itineraries visit this area</>
        )}
      </h1>
      <div className={classes.spinner}>{isFetching && <Spinner />}</div>
      <FilterButton
        className={classes.btnFilter}
        onKeyUpCapture={(event) => event.stopPropagation()}
        onMouseDownCapture={(event) => event.stopPropagation()}
        onClickCapture={showFilters}
      />
    </div>
  );
}
